//
//
//
//

export default {
    name: "TuanCustomMain"
}



// WEBPACK FOOTER //
// ./src/components/tuan/TuanCustomMain.vue